<template>
    <div class="random">
        <count :game-id="gameId"
            :selected-id="countId"
            @select="setCountId">
        </count>
    </div>
</template>

<script>
import Count from "@tv/components/partials/purchase/Count";

export default {
    props: ['countId', 'gameId'],
    components: { Count },

    computed: {
        game() {
            return Config.games[this.gameId];
        },
    },

    methods: {
        setCountId(countId) {
            this.$emit('selectCount', countId);
        },
    },
}
</script>